import { FC } from "react";
import { Chip, Typography } from "@mui/material";
import BorderRow from "../../../components/common/table/BorderRow";
import CellBox from "../../../components/common/table/CellBox";
import TooltipTypography from "../../../components/common/TooltipTypography";
import { WalletTransactionItemType } from "../../../types/walletTypes";
import { useTranslation } from "react-i18next";
import { TransactionsRowStyles } from "./TransactionTable.styles";

const TransactionsTableRow: FC<{ transaction: WalletTransactionItemType }> = ({ transaction }) => {
  const { t } = useTranslation();

  const amountColor = transaction.isPending
    ? "grey.500"
    : transaction.amount >= 0
      ? "success.main"
      : "error.main";

  let transactionReason = "";
  switch (transaction.discriminator) {
    case "ActionModuleInstance":
      transactionReason = transaction.actionModuleName ?? "-";
      break;
    case "ShopVoucher":
      transactionReason = transaction.voucherTypeName ?? "-";
      break;
    case "Normal":
    case "ShopDirectPayout":
    case "ShopCompanyPension":
      transactionReason = transaction.comment ?? "-";
      break;
    default:
      transactionReason = transaction.comment ?? "-";
      break;
  }

  return (
    <TransactionsRowStyles>
      <CellBox firstCol>
        <TooltipTypography value={transaction.sourceWalletOwnerName} />
      </CellBox>
      <CellBox>
        <TooltipTypography value={transaction.destinationWalletOwnerName} />
      </CellBox>
      <CellBox>
        {new Date(transaction.creationTimestamp).toLocaleDateString()}
      </CellBox>
      <CellBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography>{new Date(transaction.transactionTimestamp).toLocaleDateString()}</Typography>
        {transaction.isPending && (
          <Chip
            label={t("wallet.transactions.pending")}
            size="small"
            sx={{ bgcolor: "grey.200" }}
          />
        )}
      </CellBox>
      <CellBox>
        <TooltipTypography value={transactionReason} />
      </CellBox>
      <CellBox lastCol>
        <Typography sx={{ color: amountColor, fontWeight: 600 }}>
          {transaction.amount > 0 ? "+" : ""}
          {transaction.amount} {transaction.currency}
        </Typography>
      </CellBox>
      <BorderRow />
    </TransactionsRowStyles>
  );
};

export default TransactionsTableRow;
